<template>
  <div style="height: 100%;" class="modal-basicInfo">
    <el-form :model="addForm" ref="addForm" :disabled='disabled' :rules="rules">
      <el-row>
        <el-card>
          <div slot="header" class="clearfix">
            <span>基本信息</span>
          </div>
          <el-col :span="6" class="item">
            <el-form-item label="姓名" required prop="name">
              <el-input v-model="addForm.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="出生日期">
              <el-input v-model="birthday" disabled
                        placeholder="请输入出生日期"></el-input>
            </el-form-item>
            <el-form-item label="民族">
              <el-select v-model="addForm.nationId" filterable placeholder="请选择民族"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in nationValue"
                    :key="item.id"
                    :label="item.nation"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="户籍性质">
              <el-select v-model="addForm.censusRegister" placeholder="请选择户籍性质"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.natureHRegistrater"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="居住情况">
              <el-select v-model="addForm.livingStatus" placeholder="请选择居住情况"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.livingConditions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="联系电话" required prop="phone">
              <el-input v-model="addForm.phone" maxlength="11"
                        placeholder="请输入手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item label="年龄">
              <el-input v-model="age" maxlength="18" placeholder="请输入年龄" disabled></el-input>
            </el-form-item>
            <el-form-item label="政治面貌" >
              <el-select v-model="addForm.politicsStatus" placeholder="请选择政治面貌"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.politicalOutlook"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="老人类别">
              <el-select v-model="addForm.elderlyClass" placeholder="请选择老人类别"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyClassList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地区">
              <el-cascader
                  placeholder="请选择所属地区（可搜索）"
                  v-model="addForm.areaCode"
                  :options="areaValue"
                  ref="cascaderAddr"
                  :props="props"
                  @change="handleAreaChange"
                  filterable
                  style="width:100%" clearable>
              </el-cascader>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="addForm.idCard" maxlength="18"
                        @blur.native.capture="getAgeAndGender"
                        placeholder="请输入身份证号" clearable></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-input v-model="gender" maxlength="18" placeholder="请选择性别" disabled></el-input>
            </el-form-item>
            <el-form-item label="婚姻状况">
              <el-select v-model="addForm.isMarriage" placeholder="请选择婚姻状况"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.maritalValue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文化程度" prop="education">
              <el-select v-model="addForm.education" placeholder="请选择文化程度"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.education"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input v-model="addForm.homeAddress" disabled placeholder="请选择详细地址"
                        class="homeAddress">
                <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">
                  选择
                </el-button>
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="头像">
              <el-upload
                  ref="heardImg"
                  class="avatar-uploader"
                  :action="uploadUrl"
                  list-type="picture-card"
                  :data='uploadData'
                  :show-file-list="false"
                  :on-success="handleImgSuccess"
                  style="width:100%;margin-top:40px"
              >
                <el-image v-if="addForm.heardImg" :src="addForm.heardImg" fit="cover"
                          style="border-radius: 5px;" class="avatar"></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <div style="height: 36px;" >

            </div>
            <el-form-item label="所属区域" >
              <el-cascader
                  placeholder="请选择所属区域"
                  v-model="addForm.zoneCode"
                  :options="zoneValue"
                  :props="zoneProps"
                  style="width:100%" clearable >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>服务信息</span>
          </div>
          <el-col :span="18" class="item">

            <el-col :span="8" class="item">

              <el-form-item label="服务类型">
                <el-select v-model="addForm.elderlyType" placeholder="请选择服务类型"
                           style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.serviceType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="item">
              <el-form-item label="服务状态">
                <el-select v-model="addForm.serviceStatus" style="width:100%" clearable>
                  <el-option
                      v-for="item in elderlyAllType.serviceStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8" class="item">
              <el-form-item label="终端号码">
                <el-input v-model="addForm.terminalCode" clearable placeholder="请输入终端号码"></el-input>
              </el-form-item>
            </el-col> -->


          </el-col>

          <el-col :span="24" class="item">
            <el-form-item label="服务需求">
              <el-checkbox-group v-model="addForm.serviceDemand" style="margin-top:40px">
                <el-checkbox v-for="item in elderlyAllType.serviceDemand" :label="item.value" :key="item.value">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="6" class="item">-->
          <!--            <el-form-item label="老人二维码">-->
          <!--              <div class="canvas-code" id="qrcode"></div>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>紧急联系人</span>
          </div>

          <el-col :span="6" class="item">
            <el-form-item label="联系人">
              <el-input v-model="addForm.urgencyContact" clearable placeholder="请输入联系人"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="紧急电话">
              <el-input v-model="addForm.urgencyPhone" maxlength="11" clearable
                        placeholder="请输入紧急联系人电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="item">
            <el-form-item label="关系">
              <el-select v-model="addForm.relation" placeholder="请选择与紧急联系人的关系"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.relationship"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>健康状况</span>
          </div>

          <el-col :span="6" class="item">
            <el-form-item label="自理能力">
              <el-select v-model="addForm.selfCardAbility" placeholder="请选择自理能力"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.selfCareAbility"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="过敏药物">
              <el-input v-model="addForm.irritabilityMedicine" clearable
                        placeholder="请输入过敏药物"></el-input>
            </el-form-item>

            <el-form-item label="是否手术">
              <el-select v-model="addForm.isOperation" placeholder="请选择是否手术"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="6" class="item">
            <el-form-item label="心理状况">
              <el-select v-model="addForm.psychologyStatus" placeholder="请选择心理状况"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.mentalState"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="医疗保障情况">
              <el-select v-model="addForm.medicalSecurityStatus" placeholder="请选择医疗保障情况"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.medicalSecurity"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="手术原因">
              <el-input v-model="addForm.operationCause" clearable placeholder="请输入手术原因"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="6" class="item">
            <el-form-item label="血型">
              <el-select v-model="addForm.bloodType" clearable placeholder="请选择血型" style="width:100%">
                <el-option
                    v-for="item in elderlyAllType.bloodType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="主要疾病">
              <el-input v-model="addForm.illness" clearable placeholder="请输入主要疾病"></el-input>
            </el-form-item>

            <el-form-item label="手术时间">
              <el-date-picker
                  v-model="addForm.operationTime"
                  type="date"
                  placeholder="请选择手术日期"
                  :picker-options="pickerOptions0"
                  style="width:100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>生活方式</span>
          </div>

          <el-col :span="6" class="item">
            <el-form-item label="饮食习惯">
              <el-select v-model="addForm.dietaryHabit" placeholder="请选择饮食习惯"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.dietHabits"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="饮酒种类">
              <el-input v-model="addForm.drinkKind" clearable placeholder="请输入饮酒种类"></el-input>
            </el-form-item>

            <el-form-item label="每次锻炼时间">
              <el-select v-model="addForm.exerciseTime" placeholder="请选择每次锻炼时间"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.exerciseTime"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>


          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="吸烟状况">
              <el-select v-model="addForm.smokeStatus" placeholder="请选择吸烟状况"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.smokeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="体育锻炼方式">
              <el-input v-model="addForm.exerciseType" clearable placeholder="请输入体育锻炼方式"></el-input>
            </el-form-item>

          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="饮酒频率">
              <el-select v-model="addForm.drinkStatus" placeholder="请选择饮酒频率"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.drinkType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="锻炼频率">
              <el-select v-model="addForm.exerciseStatus" placeholder="请选择锻炼频率"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.exercise"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>经济状况</span>
          </div>
          <el-col :span="6" class="item">
            <el-form-item label="经济来源">
              <el-select v-model="addForm.pocketbook" placeholder="请选择经济来源"
                         style="width:100%" clearable>
                <el-option
                    v-for="item in elderlyAllType.economicSources"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="item">
            <el-form-item label="月收入">
              <el-input v-model="addForm.monthlyIncome" clearable placeholder="请输入您的月收入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="item">
            <el-form-item label="月消费">
              <el-input v-model="addForm.monthlyConsumption" clearable
                        placeholder="请输入您的月消费"></el-input>
            </el-form-item>
          </el-col>
        </el-card>

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>会员信息</span>
          </div>

          <el-col :span="6" class="item">
            <el-form-item label="会员等级">
              <el-input v-model="addForm.memberLevel" clearable
                        placeholder="请输入会员等级"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-input v-model="addForm.cardStatus" clearable
                        placeholder="请输入状态"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="卡内码">
              <el-input v-model="addForm.cardInsideCode" clearable
                        placeholder="请输入卡内码"></el-input>
            </el-form-item>
            <el-form-item label="押金">
              <el-input v-model="addForm.cashPledge" clearable
                        placeholder="请输入押金"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="item">
            <el-form-item label="卡编码">
              <el-input v-model="addForm.cardCoding" clearable
                        placeholder="请输入卡编码"></el-input>
            </el-form-item>
            <el-form-item label="有效期">
              <el-input v-model="addForm.periodOfValidity" clearable
                        placeholder="请输入有效期"></el-input>
            </el-form-item>
          </el-col>
        </el-card>
      </el-row>
    </el-form>
    <BaiduMap ref="baiduMap" v-show="baiduMapShow" v-on:colseMap="closeMap" v-on:setMap="setMap"></BaiduMap>

    <div style="background-color: white;height: 80px; width: 100% " v-show="!disabled">
      <div   style="margin-left: 43.5%;margin-top: 10px; " >
        <el-button type="primary" style="width: 26%" @click="confirm('addForm')">保存</el-button>
      </div>
    </div>


  </div>


</template>

<script>

import elderly from "@/common/status";
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import BaiduMap from "@/views/Elderly/BaiduMap";
import idcardRules from "@/common/idcardRules";
const validatorIdNumber = (rule, value, callback) => {
  if(value){
    if (idcardRules(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的证件号'))
    }
  }else{
    callback()
  }
    
};
export default {


  name: "Role",
  data() {
    return {
      baiduMapShow: false,
      uploadUrl: this.$shopUrl + 'Upload/Imgs',
      uploadData: {
        staffCode: getStaffCode(),
        timeStr: timeStr,
        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey)
      },
      elderlyClassList: '',
      age: '',
      gender: '',
      disabled:false,
      birthday: '',
      areaValue: [],
      nationValue: [],
      zoneValue:[],
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      props: {
        emitPath: false,
        value: 'areaCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listAreaDTO'
      },
      //时间范围限制
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e6
        }
      },
      addForm: {
        timeStr: timeStr,
        sign : hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        staffCode: getStaffCode(),
        areaCode: '',
        elderlyType:'',
        lon: '',
        lat: '',
        nationId: '',
        idCard: '',
        isMarriage:'',
        politicsStatus:'',
        education:'',
        censusRegister: '',
        phone:'',
        homeAddress: '',
        livingStatus:'',
        heardImg: '',
        urgencyContact:'',
        urgencyPhone:'',
        relation:'',
        selfCardAbility:'',
        psychologyStatus:'',
        bloodType:'',
        irritabilityMedicine:'',
        medicalSecurityStatus:'',
        illness:'',
        isOperation:'',
        operationCause:'',
        operationTime:'',
        dietaryHabit:'',
        smokeStatus:'',
        drinkStatus:'',
        drinkKind:'',
        exerciseType:'',
        exerciseStatus:'',
        exerciseTime:'',
        pocketbook:'',
        monthlyIncome:'',
        monthlyConsumption:'',
        memberLevel:'',
        cardInsideCode:'',
        cardCoding:'',
        periodOfValidity:'',
        serviceStatus:'',
        terminalCode:'',
        serviceDemand: [],
        name: '',
        cardStatus:'',
        cashPledge:'',
        elderlyClass:'',
        elderlyCode:'',
        zoneCode:''
      },
      rules:{
          name:[
              { required: true, message: '请输入老人姓名', trigger: 'blur' },
          ],
          phone:[
              { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          idCard:[
            { required: false,validator: validatorIdNumber, trigger: 'blur' }
          ]
      },
      elderlyAllType: elderly,
      isSave:'',
      elData:'',
      isContinue:'',
      elderlyCode:'',
    }
  },
  created() {

  },
  components: {
    BaiduMap
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
    },
  },
  methods: {
    init(isSave,elData,disabled) {
      if(disabled)this.disabled=disabled
      this.isSave=isSave;
      this.elderlyCode=elData.elderlyCode;
      this.getArea();
      this.getNation();
      this.getElderlyClassList();
      this.getZoneCode();
      this.addForm={
        timeStr: timeStr,
        sign : hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        staffCode: getStaffCode(),
        areaCode: '',
        elderlyType:'',
        lon: '',
        lat: '',
        nationId: '',
        idCard: '',
        isMarriage:'',
        politicsStatus:'',
        education:'',
        censusRegister: '',
        phone:'',
        homeAddress: '',
        livingStatus:'',
        heardImg: '',
        urgencyContact:'',
        urgencyPhone:'',
        relation:'',
        selfCardAbility:'',
        psychologyStatus:'',
        bloodType:'',
        irritabilityMedicine:'',
        medicalSecurityStatus:'',
        illness:'',
        isOperation:'',
        operationCause:'',
        operationTime:'',
        dietaryHabit:'',
        smokeStatus:'',
        drinkStatus:'',
        drinkKind:'',
        exerciseType:'',
        exerciseStatus:'',
        exerciseTime:'',
        pocketbook:'',
        monthlyIncome:'',
        monthlyConsumption:'',
        memberLevel:'',
        cardInsideCode:'',
        cardCoding:'',
        periodOfValidity:'',
        serviceStatus:'',
        terminalCode:'',
        serviceDemand: [],
        name: '',
        cardStatus:'',
        cashPledge:'',
        elderlyClass:'',
        elderlyCode:'',
        zoneCode:''
      }
      this.$refs.addForm.resetFields();
      if(this.isSave)this.getElderly();
    },
    getNation() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "SysNation/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.nationValue = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    getAgeAndGender() {
      if(idcardRules(this.addForm.idCard)){
        this.age = this.getAge();
        this.gender = this.getGender();
        this.birthday = this.getBirthday();
      }
    },
    getGender() {
      var i = this.addForm.idCard.substring(16, 17);
      if (i % 2 === 0) {
        return "女";
      } else {
        return "男";
      }
    },
    getAge() {
      var len = (this.addForm.idCard + "").length;
      var strBirthday = "";
      if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
      {
        strBirthday = this.addForm.idCard.substr(6, 4) + "/" + this.addForm.idCard.substr(10, 2) + "/" + this.addForm.idCard.substr(12, 2);
      }
      if (len == 15) {
        strBirthday = "19" + this.addForm.idCard.substr(6, 2) + "/" + this.addForm.idCard.substr(8, 2) + "/" + this.addForm.idCard.substr(10, 2);
      }
      //时间字符串里，必须是“/”
      var birthDate = new Date(strBirthday);
      var nowDateTime = new Date();
      var age = nowDateTime.getFullYear() - birthDate.getFullYear();
      //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
      if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    getBirthday() {
      var a = this.addForm.idCard.substring(6, 10);
      var b = this.addForm.idCard.substring(10, 12);
      var c = this.addForm.idCard.substring(12, 14);
      var d = a + "-" + b + "-" + c;
      return d;
    },

    getElderlyClassList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "ElderlyClass/List",
        data: {
          timeStr: timeStr,
          staffCode: getStaffCode(),
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey)
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.elderlyClassList = response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    handleImgSuccess(res, file) {
      console.log(file)
      this.addForm.heardImg = this.$imgUrl + res.data.path;
    },
    getArea() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Area/ListAll",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listAreaDTO":\[\],/g, ''))
              this.areaValue = data
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    getZoneCode(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              this.zoneValue = data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    getElderly(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/GetElderly",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.elderlyCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
             this.elData=response.data.data;

              this.elderlyInit();
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    handleAreaChange() {
      var thsAreaCode = this.$refs.cascaderAddr.getCheckedNodes()
      this.thsArea = thsAreaCode[0].parent.label
    },
    openBaiduMap() {
      this.$refs.baiduMap.init(this.thsArea);
      this.baiduMapShow = true;
    },
    closeMap() {
      this.baiduMapShow = false
    },
    setMap(info) {
      this.addForm.homeAddress = info.addressInfo
      this.addForm.lon = info.lng
      this.addForm.lat = info.lat
      this.baiduMapShow = false
    },
    confirm(addForm){

      if(this.addForm.operationTime){
        this.addForm.operationTime=timefilters(this.addForm.operationTime);
      }

      if(!this.isSave){
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            this.addSubmit();
          } else {
            this.$message({type: 'warning', message: '请完善信息'});
            return false;
          }
        })
      }else {
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            this.editSubmit();
          } else {
            this.$message({type: 'warning', message: '请完善信息'});
            return false;
          }
        })
      }



    },
    addSubmit(){
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$confirm('是否继续添加信息？','提示',{
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(()=> {
                this.isContinue=true;
                this.$emit("getElderlyData",response.data.data,this.isContinue);
              }).catch(()=> {
                this.isContinue=false;
                this.$message({type: 'success', message: '保存成功！'});
                this.$emit("getElderlyData",response.data.data,this.isContinue);
              })
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    editSubmit(){
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.elderlyCode=this.elderlyCode;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Elderly/Edit",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '保存成功！'});
              this.$emit("getElderlyData");
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    isZero(data){
      if(data===0){
        return '';
      }else {
        return data;
      }
    },
    elderlyInit(){
      this.nation=this.elData.nation;
      this.addForm.name=this.elData.name;
      if(this.elData.areaCode){
        this.addForm.areaCode=this.elData.areaCode;
      }
      this.addForm.elderlyType=this.isZero(this.elData.elderlyType);
      this.addForm.lon=this.elData.lon;
      this.addForm.lat=this.elData.lat;
      this.addForm.nationId=this.isZero(this.elData.sysNation);
      this.addForm.idCard=this.elData.idCard;
      this.addForm.isMarriage=this.isZero(this.elData.isMarriage);
      this.addForm.politicsStatus=this.isZero(this.elData.politicsStatus);
      this.addForm.education=this.isZero(this.elData.education);
      this.addForm.censusRegister=this.isZero(this.elData.censusRegister);
      this.addForm.phone=this.elData.phone;
      this.addForm.homeAddress=this.elData.homeAddress;
      this.addForm.livingStatus=this.isZero(this.elData.livingStatus);
      this.addForm.heardImg=this.elData.heardImg;
      this.addForm.urgencyContact=this.elData.urgencyContact;
      this.addForm.urgencyPhone=this.elData.urgencyPhone;
      this.addForm.relation=this.isZero(this.elData.relation);
      this.addForm.selfCardAbility=this.isZero(this.elData.selfCardAbility);
      this.addForm.psychologyStatus=this.isZero(this.elData.psychologyStatus);
      this.addForm.bloodType=this.isZero(this.elData.bloodType);
      this.addForm.irritabilityMedicine=this.elData.irritabilityMedicine;
      this.addForm.medicalSecurityStatus=this.isZero(this.elData.medicalSecurityStatus);
      this.addForm.illness=this.elData.illness;
      this.addForm.isOperation=this.isZero(this.elData.isOperation);
      this.addForm.operationCause=this.elData.operationCause;
      this.addForm.operationTime=this.elData.operationTime;
      this.addForm.dietaryHabit=this.isZero(this.elData.dietaryHabit);
      this.addForm.smokeStatus=this.isZero(this.elData.smokeStatus);
      this.addForm.drinkStatus=this.isZero(this.elData.drinkStatus);
      this.addForm.drinkKind=this.elData.drinkKind;
      this.addForm.exerciseType=this.elData.exerciseType;
      this.addForm.exerciseStatus=this.isZero(this.elData.exerciseStatus);
      this.addForm.exerciseTime=this.isZero(this.elData.exerciseTime);
      this.addForm.pocketbook=this.isZero(this.elData.pocketbook);
      this.addForm.monthlyIncome=this.elData.monthlyIncome;
      this.addForm.monthlyConsumption=this.elData.monthlyConsumption;
      this.addForm.memberLevel=this.elData.memberLevel;
      this.addForm.cardInsideCode=this.elData.cardInsideCode;
      this.addForm.cardCoding=this.elData.cardCoding;
      this.addForm.periodOfValidity=this.elData.periodOfValidity;
      this.addForm.serviceStatus=this.isZero(this.elData.serviceStatus);
      this.addForm.terminalCode=this.elData.terminalCode;
      if(this.elData.serviceDemand){
        this.addForm.serviceDemand= JSON.parse(this.elData.serviceDemand);
      }
      this.addForm.name=this.elData.name;
      this.addForm.cardStatus=this.elData.cardStatus;
      this.addForm.cashPledge=this.isZero(this.elData.cashPledge);
      this.addForm.elderlyClass=this.isZero(this.elData.elderlyClass);
      if(this.elData.idCard){
        this.getAgeAndGender();
      }
    },

  }
}
</script>

<style lang="scss" scoped>


.modal-basicInfo {


  /deep/ .el-input.is-disabled .el-input__inner {
      background-color: #fff;
      border-color: #DCDFE6;
      color: #606266;
      cursor: not-allowed;
  }
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 300px;
    height: 300px;
    margin-top: 10px;
  }
  .item{
    padding: 0 10px;
  }
  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  /deep/ .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 300px;
    line-height: 300px;
    text-align: center;
  }

  /deep/ .avatar {
    width: 300px;
    height: 300px;
    display: block;
  }

  /deep/ .el-card{
    box-shadow: none;
    border:  none;
    border-bottom: 1px solid  rgba(0,0,0,.1);
  }



}


</style>
